export default __webpack_public_path__ + "static/media/1.fdd35cb2.png";